import gql from 'graphql-tag';

export const Trend360ListQuery = gql`
	query Trend360ListQuery(
		$first: Int
		$cursor: String
		$filter: Trend360FilterInput
	) {
		entities: trend360s(first: $first, after: $cursor, filter: $filter) {
			edges {
				node {
					id
					localId
					status
					trendName
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;